import React from 'react';
import ImageGallery from 'react-image-gallery';

import 'react-image-gallery/styles/image-gallery.css';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';
import { remCss, scssVariables as variables } from 'src/helpers';
import ReactPlayer from 'react-player';
import { FileBox, MCButton, View } from '../../basic';
import { ColorRing } from 'react-loader-spinner';

export class SlideMedia extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      media: props.media,
      selectedIndex: props.selectedIndex || 0
    };
    this.escFunction = this.escFunction.bind(this);

    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  escFunction(event) {
    if (event.key === 'Escape') {
      this.props.hide();
    }
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.props.hide();
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false);
    document.addEventListener('mousedown', this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false);
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  renderNotImageItem = (item) => {
    const type = item.mimetype || item.type || '';
    const { selectedIndex, media } = this.state;
    if (item.original !== (media[selectedIndex]?.uri || media[selectedIndex])) return null;

    return (
      <div
        className={'image-gallery-image'}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          width: '100%',
          boxSizing: 'border-box',
          padding: remCss(32)
        }}
      >
        {!type.includes('video') && (
          <div
            className={'mc-flex-20'}
            style={{
              backgroundColor: 'white',
              borderRadius: remCss(10),
              padding: remCss(20),
              justifyContent: 'center'
            }}
          >
            <FileBox
              template={2}
              file={{ ...item, counter: 'slide_' + item.counter }}
              onClose={null}
              styles={{ width: remCss(50), height: remCss(50) }}
              onlyPreview={true}
              showFileName={true}
              showFileSize={true}
            />
          </div>
        )}
        {type.includes('video') && (
          <ReactPlayer
            width={'80%'}
            height={'-webkit-fill-available'}
            className={'mc-video'}
            src={item.original}
            controls={false}
            muted={true}
            playsInline={true}
            playIcon={
              <SVGIcon iconname={'play-icon'} width={40} fill={variables['colors-mc-white']} />
            }
            playing={true}
          />
        )}
      </div>
    );
  };
  renderImageItem = (item) => {
    const { selectedIndex, media } = this.state;
    if (item?.original !== (media[selectedIndex]?.uri || media[selectedIndex])) return null;
    let uri = media[selectedIndex]?.versions?.big || item?.original;

    return (
      <div
        className='image-gallery-image'
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          width: '100%',
          boxSizing: 'border-box',
          padding: remCss(32)
        }}
      >
        <img
          src={uri}
          alt={item.originalAlt || ''}
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            width: 'auto',
            height: 'auto',
            objectFit: 'contain'
          }}
        />
      </div>
    );
  };

  handleDownload = (file) => {
    if (typeof file === 'string') {
      file = { uri: file.uri };
    }
    if (this.state.downloading) return;
    this.setState({ downloading: true });

    const process = (url) => {
      const link = document.createElement('a');
      link.href = url;
      link.download = file?.name || file?.originalName || file.uri.split('/').last();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      this.setState({ downloading: false });
    };

    if (file.uri)
      fetch(file.version?.orig || file.uri)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          process(url);
        })
        .catch((error) => {
          console.error('Error fetching the file:', error);
          this.setState({ downloading: false });
        });
    else {
      const url = window.URL.createObjectURL(file);
      process(url);
    }
  };
  render() {
    const { media, selectedIndex } = this.state;
    const mediaMaps = media.map((i) => {
      if (typeof i === 'string')
        return {
          renderItem: this.renderImageItem,
          original: i,
          thumbnail: i
        };

      return {
        ...i,
        ...(!(i.mimetype || i.type).includes('image')
          ? {
              renderItem: this.renderNotImageItem,
              original: i.uri,
              thumbnail: i.thumbnail
            }
          : {
              renderItem: this.renderImageItem,
              original: i.uri,
              thumbnail: i.uri
            })
      };
    });

    return (
      <div
        data-testid='slide-media-viewer'
        ref={this.wrapperRef}
        style={{ flex: 1, display: 'flex', flexDirection: 'column', height: '100%' }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            position: 'absolute',
            right: 0,
            zIndex: 3,
            gap: remCss(20),
            padding: remCss(20)
          }}
        >
          {this.props.onViewEdit && (
            <MCButton
              onClick={this.props.onViewEdit}
              iconname={BASE_ICONS.EDIT}
              width={52}
              fill={variables['colors-mc-white']}
            />
          )}
          <MCButton
            onClick={(e) => {
              e.preventDefault();
              if (media[selectedIndex]?.uri)
                window.open(
                  media[selectedIndex].version?.orig || media[selectedIndex].uri.toString(),
                  '_blank'
                );
            }}
            iconname={BASE_ICONS.EYE_FILL}
            alt={'View original'}
            width={50}
            fill={variables['colors-mc-white']}
          />
          {this.state.downloading ? (
            <View style={{ padding: remCss(10) }}>
              <ColorRing
                colors={[
                  variables['colors-mc-white'],
                  variables['colors-mc-white'],
                  variables['colors-mc-white'],
                  variables['colors-mc-white'],
                  variables['colors-mc-white']
                ]}
                height={remCss(30)}
                width={remCss(30)}
                strokeWidth={3}
              />
            </View>
          ) : (
            <MCButton
              onClick={(e) => {
                e.preventDefault();
                if (media[selectedIndex]) this.handleDownload(media[selectedIndex]);
              }}
              iconname={BASE_ICONS.DOWNLOAD}
              width={50}
              fill={variables['colors-mc-white']}
            />
          )}
          <MCButton
            onClick={this.props.hide}
            iconname={BASE_ICONS.CLOSE}
            width={50}
            fill={variables['colors-mc-white']}
          />
        </div>
        <View
          data-testid='slide-media-gallery'
          style={{
            flex: 1
          }}
        >
          <ImageGallery
            items={mediaMaps}
            showBullets={true}
            showIndex={false}
            startIndex={selectedIndex}
            slideDuration={0}
            showThumbnails={false}
            showPlayButton={false}
            thumbnailStyle={{ height: 300 }}
            onBeforeSlide={(next) => {
              if (this.props.onSlide) this.props.onSlide(media[next]);
              this.setState({ selectedIndex: next });
            }}
          />
        </View>
      </div>
    );
  }
}
